// extracted by mini-css-extract-plugin
module.exports = {"currentDeckList":"_2ed3tTYlF-RsoMN8ARLHl2","currentDeck":"_3xA-iDJspE5j5z4s8hX8Xa","button":"_1GcI-utnzaGJiX2ctq6Ce","tableau":"_1w7v4t-5bnfqBP_VjU4QCW"};